export interface NavGroupHeaderProps {
  /** The group's name, shown when the rail is open. */
  label: string;
  /** The rail is collapsed to icons. */
  collapsed: boolean;
  /** The first group, right under the logo. */
  first: boolean;
}

/**
 * The 24px row that sits above every nav group (Figma "Admin/Sidebar" and "Admin/Rail"). The collapsed and open rail
 * both render it, and it is the same height in both, so every nav item below it stays at the same Y either way.
 *  - open: the group label (10/12 Geist 600, uppercase, tracked), vertically centred, no extra margin;
 *  - collapsed: a 1px divider centred in the block; the first group, under the logo, is a blank block.
 */
export function NavGroupHeader({ label, collapsed, first }: NavGroupHeaderProps) {
  return (
    <li
      role="presentation"
      aria-hidden={collapsed || undefined}
      className="flex h-(--mbm-space-6) shrink-0 items-center"
    >
      {collapsed ? (
        first ? null : (
          <span className="w-full border-t border-border-line" />
        )
      ) : (
        <span className="truncate px-(--mbm-space-3) text-rail-group text-text-section">{label}</span>
      )}
    </li>
  );
}
